import { render, staticRenderFns } from "./DisassembleOrderEdit.vue?vue&type=template&id=c51b0b0c&scoped=true"
import script from "./DisassembleOrderEdit.vue?vue&type=script&lang=js"
export * from "./DisassembleOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51b0b0c",
  null
  
)

export default component.exports